/**
 * The browser's IANA timezone, behind a function so callers can be tested
 * without reaching into Intl. Returns null when the environment has no
 * opinion — callers must treat that as "no corroboration", never as assent.
 */
// Resolved once per page. A product listing runs the country ladder once per
// price element — 331 of them on /producten/fotoboeken — and constructing an
// Intl.DateTimeFormat each time costs ~18ms of main thread there. The zone
// cannot change while the document is alive, so one lookup is enough.
let cached;

export const getTimeZone = () => {
  if (cached !== undefined) return cached;
  try {
    cached = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (error) {
    cached = null;
  }
  return cached;
};
